import styled from 'styled-components';


import { Link } from 'react-router-dom';

//Links principal de foooter
const LinkFooter = styled(Link)`
   
    
    color:grey;
    margin-left: 0.5%;
    font-size: 12px;
    
    
    

`;

export default LinkFooter;